import request from './request';

const timeslots = {
	async getTimeslots(query) {
		const response = await request.get('/app/timeslots', query);
		return response;
	}
};

export default timeslots;
